_atrk_opts = { atrk_acct:"Gob8i1acVE00W/", domain:"maannews.net",dynamic: true};
(function() { var as = document.createElement('script'); as.type = 'text/javascript'; as.async = true; as.src = "/static-assets/atrk.js"; var s = document.getElementsByTagName('script')[0];s.parentNode.insertBefore(as, s); })();
